import React, { PureComponent } from 'react';

export default class SimpleColorPicker extends PureComponent {
  handleClick(item) {
    if (this.props.onClick) this.props.onClick(item);
  }

  _renderColors() {
    return this.props.colors.map((item) => {
      return (
        <i
          className="individual-color fas fa-circle"
          onClick={this.handleClick.bind(this, item)}
          style={{ color: item, cursor: 'pointer' }}
          key={item}
        ></i>
      );
    });
  }

  render() {
    return (
      <div className="color-picker-wrapper">
        <div className={'card'}>
          <p>Select a color.</p>
          <div className="simple-color-picker">{this._renderColors()}</div>
        </div>
      </div>
    );
  }
}
